import React from 'react'
import { Button, Divider, Drawer, Flex, Tag } from 'antd'
import CarCard from '../../../../components/Cards/CarCard'
import { IHistoryCarInUseDetail } from '../../../../api/customer/customerApi'
import URL_CAR, { URL_CAR_CATEGORY } from '../../../../env'
import moment from 'moment'

interface Props {
  show: boolean
  infoCarInUseHistory?: IHistoryCarInUseDetail
  onClose: () => void
}

const OwnedCarDrawer: React.FC<Props> = (props) => {
  const { show, infoCarInUseHistory, onClose } = props

  return (
    <Drawer
      open={show}
      title={`${infoCarInUseHistory?.type === 0 ? "Thông tin xe đang sử dụng" : "Thông tin xe sở hữu"}`}
      className='rs-drawer'
      closeIcon={false}
      footer={
        <Button
          block
          onClick={onClose}
        >Đóng</Button>
      }
      onClose={onClose}
    >
      <Flex vertical className='gap-18px'>
        <CarCard
          name={infoCarInUseHistory?.categoryCar}
          avatar={URL_CAR + infoCarInUseHistory?.carImage}
        />
        <Flex justify='space-between' className='gap-8px'>
          <span className="neutral-gray-700">Thương hiệu</span>
          <Flex align='center' justify='flex-end' className='gap-12px'>
            <span className="neutral-gray-400 text-end">{infoCarInUseHistory?.categoryCar}</span>
            <img src={URL_CAR_CATEGORY + infoCarInUseHistory?.categoryCarImage} alt='' className='h-24px w-24px' style={{ objectFit: 'contain' }} />
          </Flex>
        </Flex>
        <Flex justify='space-between' className='gap-8px'>
          <span className="neutral-gray-700">Phân khúc</span>
          <span className="neutral-gray-400 text-end">{infoCarInUseHistory?.typeCar}</span>
        </Flex>
        <Flex justify='space-between' className='gap-8px'>
          <span className="neutral-gray-700">Dòng xe</span>
          <span className="neutral-gray-400 text-end">{infoCarInUseHistory?.carLines}</span>
        </Flex>
        <Flex justify='space-between' className='gap-8px'>
          <span className="neutral-gray-700">Loại xe</span>
          <span className="neutral-gray-400 text-end">{infoCarInUseHistory?.typeCar}</span>
        </Flex>
        <Flex justify='space-between' className='gap-8px'>
          <span className="neutral-gray-700">Mã xe</span>
          <span className="neutral-gray-400 text-end">{infoCarInUseHistory?.codeCar}</span>
        </Flex>
        <Flex justify='space-between' className='gap-8px'>
          <span className="neutral-gray-700">Màu xe</span>
          <span className="neutral-gray-400 text-end">{infoCarInUseHistory?.colorCar}</span>
        </Flex>
        <Flex justify='space-between' className='gap-8px'>
          <span className="neutral-gray-700">Năm sản xuất</span>
          <span className="neutral-gray-400 text-end">{infoCarInUseHistory?.yearManufacture}</span>
        </Flex>
        <Flex justify='space-between' className='gap-8px'>
          <span className="neutral-gray-700">Màu nội thất</span>
          <span className="neutral-gray-400 text-end"> {infoCarInUseHistory?.colorInterior}</span>
        </Flex>
        <Flex justify='space-between' className='gap-8px'>
          <span className="neutral-gray-700">Ngày mua xe</span>
          <span className="neutral-gray-400 text-end">{moment(infoCarInUseHistory?.datePurchaseCar).format('DD/MM/YYYY')}</span>
        </Flex>
        <Flex justify='space-between' className='gap-8px'>
          <span className="neutral-gray-700">Ngày nhận xe</span>
          <span className="neutral-gray-400 text-end">
            {moment(infoCarInUseHistory?.datePickUpCar).format('DD/MM/YYYY')}
          </span>
        </Flex>
        <Flex justify='space-between' className='gap-8px'>
          <span className="neutral-gray-700">Số khung</span>
          <span className="neutral-gray-400 text-end">{infoCarInUseHistory?.VIN}</span>
        </Flex>
        <Flex justify='space-between' className='gap-8px'>
          <span className="neutral-gray-700">BKS</span>
          <span className="neutral-gray-400 text-end">{infoCarInUseHistory?.BKS}</span>
        </Flex>
        <Flex justify='space-between' className='gap-8px'>
          <span className="neutral-gray-700">TVBH</span>
          <span className="neutral-gray-400 text-end">{infoCarInUseHistory?.TVBH}</span>
        </Flex>
        <Flex justify='space-between' className='gap-8px'>
          <span className="neutral-gray-700">Số hợp đồng</span>
          <span className="neutral-gray-400 text-end">{infoCarInUseHistory?.numberContract}</span>
        </Flex>
        <Flex justify='space-between' className='gap-8px'>
          <span className="neutral-gray-700">Đại lý bán xe</span>
          <span className="neutral-gray-400 text-end">{infoCarInUseHistory?.agent}</span>
        </Flex>
      </Flex>
    </Drawer>
  )
}

export default OwnedCarDrawer
